import { render, staticRenderFns } from "./gradesubject.vue?vue&type=template&id=49ce5226"
import script from "./gradesubject.vue?vue&type=script&lang=ts"
export * from "./gradesubject.vue?vue&type=script&lang=ts"
import style0 from "./gradesubject.vue?vue&type=style&index=0&id=49ce5226&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports